module.exports = __webpack_public_path__ + "img/slider (5).a8258b6c.png";